export default __webpack_public_path__ + "static/SLXGc1nY6HkvalIkTpu0xg-4fbaff0d818d08665cd7544d2ded313e.woff2";